import { Box, Button } from '@mui/material';
import JsonViewer from 'shared/JsonViewer';
import { conditionallyRenderElement } from 'utils';
import { ButtonContainer } from '../styles';
import { ProvisionIntegrationSuccessResponse } from 'IntegrationModule/api/provisionIntegrationApi';
import useAppNavigation from 'hooks/useAppNavigation';
import isEmpty from 'lodash/isEmpty';

export const ProvisionModalResponseSection: React.FC<{
  isLoading: boolean;
  error: any;
  responseData: ProvisionIntegrationSuccessResponse | undefined;
  teamId: number;
  targetService: string;
}> = ({ isLoading, error, responseData, teamId, targetService }) => {
  const { navigateToIntegrationDetailsPage } = useAppNavigation();
  return (
    <>
      <Box m={10} className="response">
        {conditionallyRenderElement({
          isLoading: isLoading,
          error: error?.data,
          renderError: () => (
            <JsonViewer
              src={{
                data: error?.data,
                status: error?.status,
              }}
            />
          ),
          content:
            isEmpty(responseData) || !responseData ? <></> : <JsonViewer src={responseData} />,
        })}
      </Box>
      <ButtonContainer>
        {responseData?.targetServiceId && (
          <Button
            className="button"
            variant="outlined"
            color="primary"
            onClick={navigateToIntegrationDetailsPage(
              teamId,
              targetService,
              responseData.targetServiceId,
            )}
          >
            See Integration
          </Button>
        )}
      </ButtonContainer>
    </>
  );
};
